/**
 * transformText
 * @param {string} text - input text
 * @returns {string} output text in kebab case
 */
export const transformText = (text) => {
  return text.replace(/ /g, '-').toLowerCase();
};
